module.exports = __webpack_public_path__ + "static/media/solution-tube-aplusfull-closed.28245cfa.svg";